import React from 'react';
import { TextField } from '@mui/material';
import { Controller, type Control, type FieldValues, type Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CompanyLimitsUsageFields } from '../utils';

interface UsageLimitsFieldsProps<T extends FieldValues & CompanyLimitsUsageFields> {
  control: Control<T>;
}

export const UsageLimitsFields = <T extends FieldValues & CompanyLimitsUsageFields>({
  control,
}: UsageLimitsFieldsProps<T>) => {
  const { t } = useTranslation();

  return (
    <>
      <Controller
        name={'callHoursMonth' as Path<T>}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            fullWidth
            label={t('superAdminMainPage.companies.companyLimits.hoursPerMonth')}
            type="number"
            inputProps={{ min: 0, step: 'any' }}
          />
        )}
      />
      <Controller
        name={'llmTokensMonth' as Path<T>}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            fullWidth
            label={t('superAdminMainPage.companies.companyLimits.llmTokensPerMonth')}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
        )}
      />
      <Controller
        name={'sttHoursMonth' as Path<T>}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            fullWidth
            label={t('superAdminMainPage.companies.companyLimits.sttHoursPerMonth')}
            type="number"
            inputProps={{ min: 0, step: 'any' }}
          />
        )}
      />
      <Controller
        name={'ttsCharactersMonth' as Path<T>}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            fullWidth
            label={t('superAdminMainPage.companies.companyLimits.ttsCharactersPerMonth')}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
        )}
      />
    </>
  );
};
